module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "w5-question-block",
    class: {
      'small': _vm.small
    }
  }, [_c('span', {
    ref: 'w5-question-block-' + _vm.Index,
    staticClass: "w5-question",
    on: {
      "click": _vm.ShowAnswer
    }
  }, [_vm._v("?")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-873701d2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/notice.vue
// module id = 536
// module chunks = 0